import { render } from "./logoWgHead.vue?vue&type=template&id=4a74ebfc&scoped=true"
import script from "./logoWgHead.vue?vue&type=script&lang=js"
export * from "./logoWgHead.vue?vue&type=script&lang=js"

import "./logoWgHead.vue?vue&type=style&index=0&id=4a74ebfc&scoped=true&lang=css"
import "./logoWgHead.vue?vue&type=style&index=1&id=4a74ebfc&lang=css"

import exportComponent from "/home/LiuJing/code/MyProjects/YiZhiWang/yizhiwang_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a74ebfc"]])

export default __exports__